import {Directive, TemplateRef} from '@angular/core';

@Directive({ selector: '[storeverDatatableColumnHeader]' })
export class DataTableColumnHeaderDirective {
  constructor(public template: TemplateRef<any>) {}
}
